import { styled } from 'styled-components';
import { Form, Select } from 'antd';
import Modal from 'src/components/Modal';

export const EachColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  .checkbox-field {
    width: auto;
    display: flex;
    flex-direction: row;
    .ant-form-item-row {
      flex-direction: row;
    }
    .ant-form-item-control {
      width: auto;
    }
    .ant-form-item-control-input {
      min-height: auto;
    }
  }
  .ant-form-item {
    padding-left: 16px;
    &.full-width {
      width: 100%;
    }
  }
  .timezone-id {
    margin-bottom: 4px;
    color: #698096;
  }
  .timezone-offset {
    .ant-form-item-row {
      flex-flow: row;
      .ant-form-item-label label {
        color: #698096;
      }
    }
    .ant-form-item-control-input {
      min-height: auto;
    }
    #timeZoneOffset {
      padding: 0;
      color: #698096;
    }
  }
`;

export const StyledModalBody = styled.div`
  position: relative;
`;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
`;
export const StyledModal = styled(Modal)`
  .ant-modal-body {
    height: 400px;
    overflow-y: scroll;
    overflow-x: hidden;
  }
  .ant-select-selector {
    height: auto !important;
  }
  .ant-select-selection-item {
    line-height: normal !important;
  }
`;
export const FormSection = styled.div`
  display: flex;
`;
export const EachRow = styled.div`
  display: flex;
  align-self: flex-end;
  .timezone-offset {
    width: 100px;
  }
  .timezone-id {
    width: 270px;
  }
`;

export const StyledTenantsTypeSelector = styled(Select)`
  min-width: 200px;
`;
